
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.786 5.008L10.896.21a.733.733 0 00-.514-.21H.727A.72.72 0 000 .714v18.552a.72.72 0 00.727.714h14.546a.72.72 0 00.727-.714V5.515a.71.71 0 00-.214-.507zm-1.463.834h-4.277V1.646l4.277 4.196zm.04 12.533H1.637V1.605H8.5v4.817c0 .249.1.487.28.662a.964.964 0 00.675.275h4.909v11.016zm-6.315-6.866L6.643 9.225a.276.276 0 00-.234-.13h-.873a.258.258 0 00-.145.043.264.264 0 00-.084.37l1.87 2.908-1.895 2.961a.265.265 0 00.093.373c.042.025.09.038.139.038h.784c.095 0 .182-.05.232-.127l1.425-2.264 1.415 2.261c.05.08.14.128.232.128h.852a.291.291 0 00.148-.043.264.264 0 00.082-.37l-1.909-2.908 1.939-2.954a.264.264 0 00-.091-.375.277.277 0 00-.139-.038h-.811a.276.276 0 00-.234.13l-1.391 2.28z","fill":"currentColor"}})])
          )
        }
      }
    